<template>
  <div class="text-element-wrapper">
    <template v-for="(item, index) in contentList">
      <span :key="index" v-if="item.name === 'text' && item.text.split('=')[0]!=code " class="text">{{
          item.text
        }}</span>
      <img
          v-else-if="item.name === 'img'"
          :src="item.src"
          width="20px"
          height="20px"
          :key="index"
      />
      <div v-else-if="item.text.split('=')[0]==code" :key="index"
           style="width: 314px;height: 120px;background: #ffffff;position: relative;cursor: pointer"
           @click="linkgo(item.text.split('=')[1].split('/')[4],item.text.split('=')[1].split('/')[5])">
        <img
            style="width: 100px;height: 100px;object-fit: cover;position:absolute;top: 50%;transform: translateY(-50%);left: 10px"
            :src="decodeURIComponent(item.text.split('=')[1].split('/')[0])" alt="">
        <p style="position: absolute;top: 10px;width: 184px;left: 120px;font-size: 18px;font-weight: bold;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
          {{ item.text.split('=')[1].split('/')[1] }}
        </p>
        <p style="position: absolute;top: 35px;width: 184px;left: 120px;font-size: 15px;overflow: hidden;text-overflow: ellipsis;display: box;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
          {{ item.text.split('=')[1].split('/')[2] }}
        </p>
        <p style="position: absolute;bottom: 10px;width: 184px;left: 120px;font-size: 15px;overflow: hidden;text-overflow: ellipsis;display: box;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;margin: 0">
          {{ item.text.split('=')[1].split('/')[3] }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import {decodeText} from "@/shared/utils/decodeText";

export default {
  name: "TextElem",
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      code: "$20200317"
    }
  },
  computed: {
    contentList() {
      return decodeText(this.payload);
    }
  },
  methods: {
    linkgo(where, id) {
      if (where == 'live') {
        window.open("https://admin.lucasgchr.com/live/form?id=" + id)
      } else {
        window.open("https://admin.lucasgchr.com/live/meeting-form?id=" + id)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  white-space: pre-wrap;
}
</style>
